import React from "react";
import OrderList from "../components/orders/OrderList";

export default function Checkout() {
  return <OrderList />;
}
